import { render, staticRenderFns } from "./fapiao.vue?vue&type=template&id=5615a481&scoped=true&"
import script from "./fapiao.vue?vue&type=script&lang=js&"
export * from "./fapiao.vue?vue&type=script&lang=js&"
import style0 from "./fapiao.vue?vue&type=style&index=0&id=5615a481&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5615a481",
  null
  
)

export default component.exports